<div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
        <div class="table-responsive" *ngIf="listaRedepositos">

            <a mdbBtn color="info" class="waves-light" mdbWavesEffect *ngIf="listaRedepositos?.length === 0">
                No existen registros para los filtros seleccionado</a>

            <table class="table table-striped table-hover table-sm align-middle" *ngIf="listaRedepositos?.length > 0">
                <thead class="grey lighten-2">
                    <tr>
                        <!-- <th scope="col">Código</th> -->
                        <th scope="col">Rut cliente</th>
                        <th scope="col">Nombre cliente</th>
                        <th scope="col">Cheque</th>
                        <th scope="col">Banco</th>
                        <th scope="col" class="text-right">Monto</th>
                        <th scope="col">Fecha</th>
                        <th scope="col">Usuario</th>
                        <th scope="col"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let redeposito of listaRedepositos">
                        <!-- <td>{{redeposito.codigo}}</td> -->
                        <td>{{redeposito.cliente_proveedor_rutFormato | rut}}</td>
                        <td>{{redeposito.cliente_proveedor_nombre}}</td>
                        <td>{{redeposito.numero_doc}}</td>
                        <td>{{redeposito.nombre_banco}}</td>
                        <td class="text-right">{{redeposito.monto | numerico}}</td>
                        <td>{{redeposito.fecha | fecha}}</td>
                        <td>{{redeposito.nombre_usuario}}</td>
                        <td>
                            <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                                (click)="loadModalRedeposito(redeposito.codigo)" mdbTooltip="Ver" placement="right">
                                <mdb-icon fas icon="eye"></mdb-icon>
                            </button>
                        </td>
                    </tr>
                </tbody>
                <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
                    *ngIf="listaRedepositos?.length > 0"></app-pagination>
            </table>
        </div>
    </div>
</div>

<div class="card mb-2 wow" *ngIf="listaRedepositos?.length > 0">
    <div class="card-body d-sm-flex p-1 justify-content-end">
        <button mdbBtn type="button" color="success" mdbWavesEffect class="btn" (click)="downloadExcel()">
            Excel
        </button>
        <button mdbBtn type="button" color="success" mdbWavesEffect class="btn">
            PDF
        </button>
    </div>
</div>

<app-cheques-redeposito-modal-add-edit-redeposito (onSuccess)="buscar()">
</app-cheques-redeposito-modal-add-edit-redeposito>